define('jquery-private',['jquery'], function ($) {
	return $.noConflict();
});
